import ProjectItemEnum from "rules/enums/project/project-item.enum"



interface IFormTypeConstant {
    label: string
    value: ProjectItemEnum
    icon: string
}

const formTypeConstant: IFormTypeConstant[] = [
    {
        label: "تخت و میز تحریر",
        value: "DESK_BED_STEAD",
        icon: "/images/form/form-type/bed.svg"
    },
    {
        label: "کابینت و کمد",
        value: "CABINET_COMMODE",
        icon: "/images/form/form-type/cabinet.svg"
    },
    {
        label: "دکور مغازه و اداری",
        value: "OFFICE_OR_SHOP_DECORATION",
        icon: "/images/form/form-type/decor.svg"
    },
    {
        label: "جاکفشی و کتابخانه",
        value: "SHOES_BOX_SHELVE_LIBRARY",
        icon: "/images/form/form-type/shoesbox.svg"
    },
    {
        label: "میز و میزتلوزیون",
        value: "TABLE_TV_STAND_DRAWER",
        icon: "/images/form/form-type/tvtable.svg"
    },
    {
        label: "بازسازی",
        value: "RENOVATION",
        icon: "/images/form/form-type/renovation.svg"
    }
]

export default formTypeConstant